import React, {Component} from 'react';
import Wrapper from './Wrapper';
import '../../App.css'; // include the contents - last 2 lines
import Notifications, {notify} from 'react-notify-toast';
import { Redirect } from 'react-router-dom';
// let addColor = { background: '#61D19E', text: "#FFFFFF" }; let removeColor =
// { background: '#b2346d', text: "#FFFFFF" };
// const DEFAULT = {
//   rows: ['lab'],
//   cols: ['assay', 'registered'],
//   data: []
// }
const HIDDEN_KEYS = [
  '_id',
  '_index',
  'count',
  'dose',
  'experiments',
  'project',
  'title',
  'selected',
  'uuid',
  'filename'
]
class TableMain extends Component {

  state = {
    data: this.props.data,
    setViewRedirectLink: null
  }

  show = () => notify.createShowQueue()

  handleDataSelection = (list) => {
    const redirectLink = constructCellRedirectLink(list);
    this.setState({ setViewRedirectLink: redirectLink });
    // var win = window.open(redirectLink);
    // win.focus();
    // if (list.length > 0) {   let _data = [...this.state.data]   let afterUpdates
    // = updateSelectFlag(_data, list)   let datasetsAdded = afterUpdates[1]   let
    // datasetsRemoved = afterUpdates[2]   this.setState({data: afterUpdates[0]}) if
    // (datasetsAdded > 0) {     notify.show(`${datasetsAdded} datasets added 🛒`,
    // "custom", 1000, addColor)   }   if (datasetsRemoved > 0) {
    // notify.show(`${datasetsRemoved} datasets removed 🛒`, "custom", 1000,
    // removeColor)   } }
  }
  // TODO: upgrade componentWillReceiveProps to getDerivedStateFromProps, will be
  // deprecated in React 17 static getDerivedStateFromProps(props, current_state)
  // {   if (current_state.data.length !== props.data.length) {     return {
  // data: props.data };   } else {     return null;   } }

  componentWillReceiveProps(nextProps) {
    this.setState({data: nextProps.data});
  }

  render() {
    if (this.state.setViewRedirectLink) {
      return <Redirect to={this.state.setViewRedirectLink} />
    }
    if (this.state.data.length === 0) {
      return <div>Loading ...
      </div>
    }
    return (
      <div className="App">
        <Notifications/>
        <div id="wrapper_1">
          <div id="container_1">
            <Wrapper
              data={this.state.data}
              default={this.props.DEFAULT}
              hide={HIDDEN_KEYS}
              onDataSelect={this.handleDataSelection}/>
          </div>
        </div>
      </div>
    );
  }
}

export default TableMain;
/*
function updateSelectFlag (_data, list) {
  let trueToFalse = 0
  let falseToTrue = 0
  _data.forEach(d => {
    if (list.includes(d.name) || list.includes(d)) {
      d.selected ? trueToFalse++ : falseToTrue++
      d.selected = !d.selected
    }
  })
  return [_data, falseToTrue, trueToFalse]
}

function addSelectedFlag(data) {

    data.forEach(d => {
      if (DEFAULT.data.includes(d.id)){
        d['selected'] = true
      } else {
        d['selected'] = false
      }
    })

    return data
  }
*/
// count=1&tissue=Liver&age_of_mice=5%20months&assay_technique=RNA-seq&lab=Chery
// l%20Walker&exposure_type=Control&mouse_gender=Male
function constructCellRedirectLink(list) {
  const correctNAMES = {
    "tissue": "tissue_list",
    "assay_technique": "assay_list",
    "lab": "lab_list",
    "exposure_type": "exposure_list"
  };
  let tmp = [];
  Object
    .keys(list)
    .forEach(item => {
      if (correctNAMES[item]) {
        tmp.push(`${correctNAMES[item]}=["${list[item]}"]`);
      }
    });
  let listSpreadConcat = "/set/?" + tmp.join('&');
  const params = getSearchStringFromURL();
  if (params['search']) {
    listSpreadConcat = encodeURI(listSpreadConcat) + '&search=' + params['search'];
  }

  return listSpreadConcat;
}

function getSearchStringFromURL() {

  var regex = /[?&]([^=#]+)=([^&#]*)/g,
        url= window.location.href,
        params = {},
        match;
    // eslint-disable-next-line
    while(match = regex.exec(url)) {
        params[match[1]] = match[2];
    }

    return params;
}


// WEBPACK FOOTER //
// ./src/components/pivottable/index.js